import React, { useEffect, useState } from "react";
import { errorToast } from "../../../Utils/Toast/Toast";
import { getAllOrderApi } from "../../../Api/PanelAdminServices";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import AllOrderPeykTable from "../../Tables/AllOrderPeyk/AllOrderPeykTable/AllOrderPeykTable";
import { Modal } from "react-bootstrap";
import UserInfo from "../../Modal/Information/UserInfo/UserInfo";
import PayingToWho from "../../Modal/Information/PayingToWho/PayingToWho";
import DeliveryInfo from "../../Modal/Information/DeliveryInfo/DeliveryInfo";
import OrderListAllPeyk from "../../Modal/Information/OrderListAllPeyk/OrderListAllPeyk";

const AllOrderPeykContainer = () => {
  const [orders, setOrders] = useState([]);
  const [orderDetail, setOrderDetail] = useState([]);
  const [walletTransactions, setwalletTransactions] = useState([]);
  const [Info, setInfo] = useState([]);
  const [isOrderVisible, setIsOrderVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalDeliver, setModalDeliver] = useState(false);
  const [payingModal, setPayingModal] = useState(false);
  useEffect(() => {  
    getAcceptedSupplier();
  }, []);
  const getAcceptedSupplier = async () => {
    getAllOrderApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          const filteredData=res.orders.filter(el=>{
            return el.order_type==="magic"
          })
          setOrders(filteredData)
            
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  const data =
    orders &&
    orders.map((item, index) => {
      return {
        key: index,
        person: item.first_name + " " + item.last_name,
        city: item.city,
        orderNumber: item.id,
        date: item.date,
        supplierId: item.supplier_id,
        userId: item.user_id,
        address: item.address,
        phone: item.user_phone,
        supplier: item.suppliers,
        walletTransactions: item.wallet_transactions,
        deliverCode: item.delivery_code,
        deliveryPrice: item.delivery_price,
        deliverPrice: item.deliver_price,
        status: item.status,
        deliverInfo: item.deliver,
      };
    });
  const showModal = async (id, info) => {
      setInfo(info);
      setOrderDetail(info.supplier);
      setwalletTransactions(info.walletTransactions);
    //////// user Info /////////
    if (id === 1) {
      setIsModalVisible(true);
    }

    //////// order List ////////
    if (id === 2) {
      setIsOrderVisible(true);
    }

    //////// pay to who ////////
    if (id === 3) {
      setPayingModal(true);
    }

    //////// peyk info ////////
    if (id === 4) {
      setModalDeliver(true);
    }

  };

  const handleOk = () => {
    setIsModalVisible(false);
    setIsOrderVisible(false);
    setPayingModal(false);
    setModalDeliver(false);
  };

  ///// style /////////
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
    fontSize: "1.1rem",
    fontFamilly: "iran-sans",
  };
  return (
    <div>
      <Modal show={isModalVisible} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات مشتری</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserInfo Info={Info} showAddress={true} handleOk={handleOk} />
        </Modal.Body>
      </Modal>

      <Modal show={isOrderVisible} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>لیست سفارش</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrderListAllPeyk Info={Info} item={orderDetail} handleOk={handleOk} />
        </Modal.Body>
      </Modal>

      <Modal show={modalDeliver} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات پیک</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <DeliveryInfo Info={Info.deliverInfo} handleOk={handleOk} /> */}
        </Modal.Body>
      </Modal>

      <Modal show={payingModal} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>هزینه های پرداختی</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PayingToWho data={walletTransactions} handleOk={handleOk} />
        </Modal.Body>
      </Modal>
      <TableFixedPage title={"همه سفارشات درخواست پیک "} />
      <AllOrderPeykTable 
      showModal={showModal} 
      data={data} />
    </div>
  );
};

export default AllOrderPeykContainer;
